<template>
  <div v-if="dadosProposta.dadosCliente" class="wrapperPage pt-8">
    <div
      class="sm:pl-0 container flex flex-col items-center sm:flex-row sm:justify-between"
    >
      <div class="logo sm:w-1/2 w-full">
        <img src="../../assets/images/logo/logo-bpseguradora.svg" width="150" />
      </div>
      <div class="dadosBP w-full sm:w-1/2 flex flex-col p-1 text-sm">
        <h3 class="sm:flex justify-end">LAUDO DE VISTORIA</h3>
        <p class="sm:flex justify-end">
          CNPJ: {{ dadosProposta.dadosAssociacao.cnpj }}
        </p>
        <p class="sm:flex justify-end">
          {{ dadosProposta.dadosAssociacao.endereco }},
          {{ dadosProposta.dadosAssociacao.numero }}
          {{ dadosProposta.dadosAssociacao.complemento }} -
          {{ dadosProposta.dadosAssociacao.bairro }} -
          {{ dadosProposta.dadosAssociacao.cidade }},
        </p>
        <p class="sm:flex justify-end">
          {{ dadosProposta.dadosAssociacao.estado }} - CEP:
          {{ dadosProposta.dadosAssociacao.cep }}
        </p>
      </div>
    </div>
    <div></div>
    <div class="container">
      <vx-card class="mt-5">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">DADOS DA VISTORIA</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Contratante</b>: {{ dadosProposta.dadosCliente.associado }}
            </td>
            <td class="pl-3">
              <b>Vistoriador</b>:
              {{
                dadosProposta.vistoriaFeitaPeloConsultor
                  ? dadosProposta.dadosVendedor.usuario
                  : 'Segurado'
              }}
            </td>
            <td class="pl-3"><b>Solicitante</b>: BEM PROTEGE</td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Data Cadastro</b>:
              {{ formataData(this.dadosProposta.createdAt) }}
            </td>
            <td class="pl-3">
              <b>Data Realização</b>:
              {{
                this.dadosProposta.dataVistoria != 'Invalid date'
                  ? formataData(this.dadosProposta.dataVistoria)
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Local</b>:
              {{
                dadosProposta.regionalCidade ? dadosProposta.regionalCidade : ''
              }}
            </td>
          </tr>
        </table>
      </vx-card>
      <vx-card class="mt-3">
        <table class="table table-bordered">
          <tr class="title p-1 w-full">
            <th colspan="4">DADOS DO ASSOCIADO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Nome</b>:
              {{
                dadosProposta.dadosCliente.associado
                  ? dadosProposta.dadosCliente.associado
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>CPF / CNPJ</b>:
              {{
                dadosProposta.dadosCliente.cpf
                  ? dadosProposta.dadosCliente.cpf
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>E-mail</b>:
              {{
                dadosProposta.dadosCliente.email
                  ? dadosProposta.dadosCliente.email
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>RG</b>:
              {{
                dadosProposta.dadosCliente.rg_ie
                  ? dadosProposta.dadosCliente.rg_ie
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Telefone</b>:
              {{
                dadosProposta.dadosCliente.telefone
                  ? dadosProposta.dadosCliente.telefone
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>Celular</b>:
              {{
                dadosProposta.dadosCliente.celular
                  ? dadosProposta.dadosCliente.celular
                  : ''
              }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>CNH</b>:
              {{
                dadosProposta.dadosCliente.cnh
                  ? dadosProposta.dadosCliente.cnh
                  : ''
              }}
            </td>
            <td class="pl-3">
              <b>N° Proposta</b>:
              {{ dadosProposta.idProposta ? dadosProposta.idProposta : '' }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Data de Nascimento</b>:
              {{
                dadosProposta.dadosCliente.dataNascimento != 'Invalid date'
                  ? dadosProposta.dadosCliente.dataNascimento
                  : ''
              }}
            </td>
            <td class="pl-3"></td>
          </tr>
        </table>
      </vx-card>
      <vx-card class="mt-3 ajustePrint">
        <table class="table">
          <tr class="title p-1 w-full">
            <th colspan="4">DADOS DO VEÍCULO</th>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Ano Fabricação</b>:
              {{
                dadosProposta.dadosVeiculo.anoFabricacao == '32000'
                  ? '0Km'
                  : dadosProposta.dadosVeiculo.anoFabricacao
              }}
            </td>
            <td class="pl-3" colspan="2">
              <b>Ano Modelo</b>:
              {{
                dadosProposta.dadosVeiculo.anoModelo == '32000'
                  ? '0Km'
                  : dadosProposta.dadosVeiculo.anoModelo
              }}
            </td>
            <td class="pl-3">
              <b>Renavam</b>: {{ dadosProposta.dadosVeiculo.renavam }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Marca</b>: {{ dadosProposta.dadosVeiculo.veiculoMarca }}
            </td>
            <td class="pl-3" colspan="3">
              <b>Modelo</b>: {{ dadosProposta.dadosVeiculo.veiculoModelo }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="2">
              <b>Chassi</b>: {{ dadosProposta.dadosVeiculo.chassi }}
            </td>
            <td class="pl-3">
              <b>Placa</b>: {{ dadosProposta.dadosVeiculo.placa }}
            </td>
          </tr>
          <tr>
            <td class="pl-3">
              <b>Cor</b>: {{ dadosProposta.dadosVeiculo.cor }}
            </td>
            <td class="pl-3" colspan="3">
              <b>Quilometragem</b>: {{ dadosProposta.dadosVeiculo.km }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="4">
              <b>Franquia</b>: {{ dadosProposta.valorCotaParticipacao }}% FIPE,
              mínimo de
              {{ dadosProposta.valorParticipacaoMinimo | currency }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="4">
              <b>Observações do Vistoriador</b>: {{ dadosProposta.observacao }}
            </td>
          </tr>
          <tr>
            <td class="pl-3" colspan="4">
              <b>Acessórios</b>:
              <span
                v-for="acessorio in dadosProposta.acessorios"
                :key="acessorio.idAcessorio"
              >
                {{ acessorio.descricao }},
              </span>
            </td>
          </tr>
        </table>

        <!-- implementos -->
        <div v-if="dadosProposta.implemento">
          <table
            v-for="(implemento, index) in dadosProposta.implementos"
            :key="`id-${index}`"
            class="table mt-6"
          >
            <tr v-if="index == 0" class="title p-1 w-full">
              <th colspan="4">
                {{
                  dadosProposta.implementos.length > 1
                    ? 'DADOS DOS IMPLEMENTOS'
                    : 'DADOS DO IMPLEMENTO'
                }}
              </th>
            </tr>
            <tr>
              <td class="pl-3"><b>Tipo</b>: {{ implemento.tipo }}</td>
              <td class="pl-3"><b>Marca</b>: {{ implemento.marca }}</td>
              <td class="pl-3"><b>Modelo</b>: {{ implemento.modelo }}</td>
            </tr>
            <tr v-if="implemento.anoFabricacao || implemento.anoModelo">
              <td v-if="implemento.anoFabricacao" class="pl-3">
                <b>Ano Fabricação</b>:
                {{
                  implemento.anoFabricacao == '32000'
                    ? '0Km'
                    : implemento.anoFabricacao
                }}
              </td>
              <td v-if="implemento.anoModelo" class="pl-3">
                <b>Ano Modelo</b>:
                {{
                  implemento.anoModelo == '32000' ? '0Km' : implemento.anoModelo
                }}
              </td>
            </tr>
            <tr v-if="implemento.chassi || implemento.placa">
              <td class="pl-3"><b>Chassi</b>: {{ implemento.chassi }}</td>
              <td class="pl-3"><b>Placa</b>: {{ implemento.placa }}</td>
              <td class="pl-3">&nbsp;</td>
            </tr>
          </table>
        </div>

        <!-- agregados -->
        <div v-if="dadosProposta.agregado">
          <table
            v-for="(agregado, index) in dadosProposta.agregados"
            :key="`id-${index}`"
            class="table mt-6"
          >
            <tr v-if="index == 0" class="title p-1 w-full">
              <th colspan="4">
                {{
                  dadosProposta.agregados.length > 1
                    ? 'DADOS DOS AGREGADOS'
                    : 'DADOS DO AGREGADO'
                }}
              </th>
            </tr>
            <tr>
              <td class="pl-3"><b>Tipo</b>: {{ agregado.tipo }}</td>
              <td class="pl-3"><b>Marca</b>: {{ agregado.marca }}</td>
              <td class="pl-3"><b>Modelo</b>: {{ agregado.modelo }}</td>
            </tr>
            <tr v-if="agregado.anoFabricacao || agregado.anoModelo">
              <td v-if="agregado.anoFabricacao" class="pl-3">
                <b>Ano Fabricação</b>:
                {{
                  agregado.anoFabricacao == '32000'
                    ? '0Km'
                    : agregado.anoFabricacao
                }}
              </td>
              <td v-if="agregado.anoModelo" class="pl-3">
                <b>Ano Modelo</b>:
                {{ agregado.anoModelo == '32000' ? '0Km' : agregado.anoModelo }}
              </td>
            </tr>
            <tr v-if="agregado.chassi || agregado.placa">
              <td class="pl-3"><b>Chassi</b>: {{ agregado.chassi }}</td>
              <td class="pl-3"><b>Placa</b>: {{ agregado.placa }}</td>
              <td class="pl-3">&nbsp;</td>
            </tr>
          </table>
        </div>
      </vx-card>
      <vx-card class="mt-3">
        <table>
          <tr class="title p-1 w-full">
            <th colspan="4">FOTOS DA VISTORIA</th>
          </tr>
          <tr v-for="foto in fotos" :key="foto.id_modelofoto">
            <td class="p-3 sm:flex sm:justify-between">
              <video
                class="videoVistoria"
                v-if="verificaExtensaoVideo(foto.nome)"
                controls
                muted
                loop
                :src="foto.nome"
              ></video>

              <img
                class="fotoVistoria"
                v-if="verificaExtensaoImagem(foto.nome)"
                :src="foto.nome"
              />

              <div class="mb-1 sm:text-left">
                <p>
                  <b>{{ foto.nomePosicao }}</b>
                </p>
                <br />
                <p v-if="foto.latitude"><b>Latitude: </b>{{ foto.latitude }}</p>
                <p v-if="foto.latitude">
                  <b>Longitude: </b>{{ foto.longitude }}
                </p>
                <p v-if="foto.latitude">
                  <b>Endereço: </b>{{ foto.endereco.road }} -
                  {{ foto.endereco.city }}
                </p>
                <p><b>Data criação: </b>{{ formataData(foto.createdAt) }}</p>
                <p v-if="foto.observacaoVistoria">
                  <b>Observação: </b>{{ foto.observacaoVistoria }}
                </p>
              </div>
            </td>
          </tr>
        </table>
      </vx-card>

      <vx-card class="mt-3">
        <table>
          <tr class="title p-1 w-full">
            <th colspan="4">ASSINATURA DO SEGURADO</th>
          </tr>

          <tr>
            <td colspan="4">
              <div class="assinatura text-center">
                <img
                  v-if="dadosProposta.assinatura"
                  class="imagem"
                  :src="dadosProposta.assinatura"
                  height="100"
                  style="margin: auto"
                />
                <p><b>____________________________________</b></p>
                <p>
                  <b>{{ dadosProposta.dadosCliente.associado }}</b>
                </p>
                <P
                  ><b>{{ dadosProposta.dadosCliente.cpf }}</b></P
                >
              </div>
            </td>
          </tr>
        </table>
      </vx-card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import service from '../../services';
import locale from './../../locale';
import VxCard from '../../components/vx-card/VxCard.vue';
import axios from 'axios';

export default {
  data() {
    return {
      dadosProposta: {},
      tiposFotos: ['Todas', 'Aprovadas', 'Reprovadas', 'Não Trabalhadas'],
      fotosGerais: [],
      fotos: [],
    };
  },
  computed: {},
  methods: {
    imprimePDF() {
      window.print();
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    somaValorTotalValoresAvista(arr1) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal != true) total = total + element.valorFinal;
        });
      return total;
    },
    somaValorTotalMensal(arr1) {
      var total = 0;
      if (arr1 && arr1.length > 0)
        arr1.forEach((element) => {
          if (element.isMensal == true) total = total + element.valorFinal;
        });
      return total;
    },

    verificaExtensaoImagem(link) {
      if (link) {
        if (link.split('/')[0] == 'data:image') return true;
        var ext = link.split('.').pop();
        this.tipoFoto = ext;
        if (ext == 'png' || ext == 'jpeg' || ext == 'jpg') return true;
        else return false;
      } else return false;
    },
    verificaExtensaoVideo(link) {
      if (link) {
        if (link.split('/')[0] == 'data:video') return true;
        var ext = link.split('.').pop();
        this.tipoFoto = ext;
        if (ext == 'gif' || ext == 'mp4') return true;
        else return false;
      } else return false;
    },
    buscaDados() {
      this.$vs.loading();
      var objSend = {};
      objSend.idProposta = this.$route.params.idProposta;
      objSend.qtdPorPagina = this.itemsPerPage;
      objSend.idEmpresa = this.idEmpresa;
      objSend.chave = this.$route.params.chave;

      this.logo = localStorage.getItem('logo');
      service
        .post('CotacaoAberta', 'buscaDados', objSend)
        .then((res) => {
          if (res.data.length > 0) {
            this.dadosProposta = res.data[0];
            this.buscaFotos();
            this.$vs.loading.close();
          } else {
            this.$vs.notify({
              position: 'top-center',
              title: 'Atenção',
              text: 'Você não tem acesso a visualização desta Proposta/Vistoria',
              color: 'danger',
            });
            this.$vs.loading.close();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
    reverseCoordenates(lat, log) {
      return new Promise((resolve, reject) => {
        var end = `https://nominatim.openstreetmap.org/reverse?&format=json&lat=${lat}&lon=${log}&zoom=21&addressdetails=1`;
        axios
          .get(end)
          .then((res) => {
            resolve(res);
          })
          .catch((e) => {
            reject(e);
          });
      });
    },
    buscaFotos() {
      this.$vs.loading();

      var objSend = {};
      objSend.idProposta = this.dadosProposta.idProposta;
      objSend.idEmpresa = this.dadosProposta.idEmpresa;
      service
        .post('CotacaoAberta', 'listarFotosCotacao', objSend)
        .then(async (res) => {
          this.fotos = [];
          for await (const element of res.data) {
            if (element.latitude) {
              await this.reverseCoordenates(element.latitude, element.longitude)
                .then((resultcor) => {
                  element.endereco = resultcor.data.address;
                })
                .catch((e) => {
                  element.endereco = `Não identificado (${element.latitude},${element.longitude})`;
                });
            } else element.endereco = 'Não identificado';

            this.fotos.push(element);
          }
          this.isMounted = true;
          this.$vs.loading.close();
        })
        .catch((e) => {
          this.$vs.notify({
            position: 'top-center',
            title: 'Atenção',
            text: e,
            color: 'danger',
          });
          this.$vs.loading.close();
        });
    },
  },
  mounted() {},
  created() {
    this.buscaDados();
    this.$validator.localize('ptBr', locale);
  },
  components: { VxCard },
};
</script>

<style>
@import url('https://fonts.cdnfonts.com/css/gotham');

.wrapperPage {
  font-family: 'regular', 'Gotham', sans-serif;
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
}

table {
  width: 100%;
  gap: 20px;
}

tr:nth-child(odd) {
  background-color: #edf4fb;
}

.fotoVistoria {
  max-width: 300px;
}

.videoVistoria {
  max-width: 300px;
  max-height: 197px;
}

.title {
  background-color: #043562 !important;
  color: white;
}

.listItemsProtecoes {
  color: rgb(59, 59, 59);
  font-size: 0.9rem;
  font-weight: 600;
}

.A3 .sheet {
  width: 297mm;
  height: 419mm;
}

.A3.landscape .sheet {
  width: 420mm;
  height: 296mm;
}

.A4 .sheet {
  width: 210mm;
  height: 296mm;
}

.A4.landscape .sheet {
  width: 297mm;
  height: 209mm;
}

.A5 .sheet {
  width: 148mm;
  height: 209mm;
}

.A5.landscape .sheet {
  width: 210mm;
  height: 147mm;
}

/** Padding area **/
.sheet.padding-10mm {
  padding: 10mm;
}

.sheet.padding-15mm {
  padding: 15mm;
}

.sheet.padding-20mm {
  padding: 20mm;
}

.sheet.padding-25mm {
  padding: 25mm;
}

/** For screen preview **/
@media screen {
  body {
    background: #e0e0e0;
    justify-content: center;
  }

  .sheet,
  .quebraPagina {
    background: white;
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3);
    margin-top: 1em;
    margin-bottom: 1em;
  }
}

/** Fix for Chrome issue #273306 **/
@media print {
  .A3.landscape {
    width: 420mm;
  }

  .A3,
  .A4.landscape {
    width: 297mm;
  }

  .A4,
  .A5.landscape {
    width: 210mm;
  }

  .A5 {
    width: 148mm;
  }

  .A4,
  .ajustePrint {
    margin-bottom: 300px;
  }
}

@media screen {
  .printer {
    display: none;
  }
}

@media print {
  .non-printer {
    display: none;
  }

  .vue-back-to-top {
    display: none !important;
  }

  .pdf {
    width: auto;
    height: 200mm;
  }

  .folha {
    height: 297mm;
    padding: 0 0 0 0;
    page-break-after: always;
  }

  .btn-print {
    display: none;
  }

  #content-area {
    margin-left: 0px;
  }

  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }

  .vs-content-sidebar,
  .router-header,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }

  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }

  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }

  .td-check {
    visibility: hidden;
  }
}
</style>
